import { render, staticRenderFns } from "./ImpressaoRelatorioIndividual.vue?vue&type=template&id=48b02204&scoped=true&"
import script from "./ImpressaoRelatorioIndividual.vue?vue&type=script&lang=js&"
export * from "./ImpressaoRelatorioIndividual.vue?vue&type=script&lang=js&"
import style0 from "./ImpressaoRelatorioIndividual.vue?vue&type=style&index=0&id=48b02204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b02204",
  null
  
)

export default component.exports